<template>
    <div class="top-backview" ref="topBackview">
        <div class="contnet-backview" ref="contentBackview">
            <homeBannerView
                :bannerimg="images"
                :isVideo="true"
                type="home"
            ></homeBannerView>
            <div class="banner-bottomLine"></div>
            <div class="center-contentview">
              <div class="section1">
                  <!-- <div class="common-title">
                      <img src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/title-icon.png" alt="">
                      <span>{{ $t('h.homes1tit') }}</span>
                  </div> -->
                  <div class="flex1">
                    <div class="flip-card">
                      <div class="flip-inner">
                        <div class="c1 flip-front">
                          <img class="s1-icon" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/rounds.png" alt="">
                          <div class="s1-tit">{{ $t('h.homes1rounds') }}</div>
                        </div>
                        <div class="c1 flip-back">
                          <div class="s1-text">{{ $t('h.homes1roundsDesc') }}</div>
                          <div class="page-btn" @click="seeMore(1)">SEE MORE</div>
                        </div>
                      </div>
                    </div>
                      <div class="flip-card">
                      <div class="flip-inner">
                        <div class="c2 flip-front">
                          <img class="s1-icon" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/culture.png" alt="">
                          <div class="s1-tit">{{ $t('h.homes1culture') }}</div>
                        </div>
                        <div class="c2 flip-back">
                          <div class="s1-text">{{ $t('h.homes1cultureDesc') }}</div>
                          <div class="page-btn" @click="seeMore(2)">SEE MORE</div>
                        </div>
                      </div>
                    </div>
                      <div class="flip-card">
                      <div class="flip-inner">
                        <div class="c3 flip-front">
                          <img class="s1-icon" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/target.png" alt="">
                          <div class="s1-tit">{{ $t('h.homes1target') }}</div>
                        </div>
                        <div class="c3 flip-back">
                          <div class="s1-text">{{ $t('h.homes1targetDesc') }}</div>
                          <!-- <div class="page-btn">SEE MORE</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="section2">
                <div class="common-title">
                  <img src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/title-icon.png" alt="">
                  <span>{{ $t('h.homes2tit') }}</span>
                </div>
                <div class="s2-con">
                  <div class="s2-con-inner">
                  <div class="s2-tab">
                    <div class="s2-tab-item" :class="tabIndex === i ? 'active' : ''" v-for="(item, i) in tabs" :key="i" @click="switchTab(i)">
                      <div class="t1">{{ item.t1 }}</div>
                      <div class="t2">{{ $t('h.homes2nationalChampion') }}</div>
                    </div>
                  </div>
                  <div class="s2-main-wrap" :style="{ height: s2MainHeight }">
                    <transition :name="slideName">
                      <div class="flex1 s2-main" :key="'s2-' + tabIndex + '-' + $i18n.locale" ref="s2Main">
                        <div>
                          <div class="tit1">{{ i18nTabs[tabIndex].name }}</div>
                          <div class="tit2">{{ i18nTabs[tabIndex].area }}</div>
                          <div class="tit2">{{ i18nTabs[tabIndex].grade }}</div>
                          <div class="page-btn upper">{{ $t('h.homes2ChampionInterviews') }}</div>
                        </div>
                        <img class="photo" :src="tabs[tabIndex].img" alt="" @load="setS2MainHeight">
                      </div>
                    </transition>
                  </div>
                  </div>
                </div>
              </div>
              <div class="section3">
                <div class="common-title">
                  <img src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/title-icon.png" alt="">
                  <span>{{ $t('h.homes3tit') }}</span>
                </div>
                <div class="s3-con flex2">
                  <img src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/home-s3.png" alt="">
                  <div>
                    <div class="flex1">
                      <div class="s3-tab-item">
                        <div class="t1 upper">{{ $t('h.homes3ELearnKit') }}</div>
                        <div class="t2">{{ $t('h.homes3ELearnKitDesc') }}</div>
                      </div>
                      <div class="s3-tab-item">
                        <div class="t1 upper">{{ $t('h.homes3MiniProgram') }}</div>
                        <div class="t2">{{ $t('h.homes3MiniProgramDesc') }}</div>
                      </div>
                      <div class="s3-tab-item">
                        <div class="t1 upper">{{ $t('h.homes3WebPlatform') }}</div>
                        <div class="t2">{{ $t('h.homes3WebPlatformDesc') }}</div>
                      </div>
                    </div>
                    <div class="page-btn page-btn2">
                      {{ $t('h.homes3ExploreBtn') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="section4">
                <div class="common-title">
                  <img src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/title-icon.png" alt="">
                  <span>{{ $t('h.homes4tit') }}</span>
                </div>
                <div class="scroll-container">
                  <div class="scroll-track">
                    <div class="s4-item" v-for="(item, index) in i18nS4List" :key="'a-' + index">
                      <div class="t1">{{ item.username }}</div>
                      <div class="t2">{{ item.grade }}</div>
                      <div class="star">
                        <img v-for="(star,s) in 5" :key="s" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/star.png" alt="">
                      </div>
                      <div class="t3">{{ item.content }}</div>
                    </div>
                    <!-- 无缝复制一份 -->
                    <div class="s4-item" v-for="(item, index) in i18nS4List" :key="'b-' + index">
                      <div class="t1">{{ item.username }}</div>
                      <div class="t2">{{ item.grade }}</div>
                      <div class="star">
                        <img v-for="(star,s) in 5" :key="s" src="https://cdn.spbcn.org/spbcnWeb/cebsb/web/star.png" alt="">
                      </div>
                      <div class="t3">{{ item.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: none;">
                <!-- Global Partner Section -->
                <div class="homepage-section global-partner-section">
                    <div class="global-partner-content">
                        <div class="global-partner-left">
                            <div class="global-partner-subtitle">ABOUT CEBSB</div>
                            <div class="global-partner-title">BECOME A GLOBAL PARTNER</div>
                            <div class="global-partner-description">
                                let students in your community shine on the CEBSB stage! Join us to empower growth through academics and ignite lifelong curiosity!
                            </div>
                            <div class="global-partner-button" @click="goToPartner">
                                CLICK TO LEARN HOW TO BRING CEBSB TO YOUR COMMUNITY →
                            </div>
                        </div>
                        <div class="global-partner-right">
                            <div class="global-partner-panel">
                                <img
                                    src="https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_img_1.png"
                                    alt="Global Partner"
                                    class="global-partner-image"
                                />
                                <div class="global-partner-vertical-text">WE ARE PARTNER</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bilingual Spelling Resources Section -->
                <div class="homepage-section resources-section">
                    <div class="resources-content">
                        <div class="resources-left">
                            <img
                                src="https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_img2_20260629.jpg"
                                alt="Bilingual Spelling Resources"
                                class="resources-image"
                            />
                        </div>
                        <div class="resources-right">
                            <div class="resources-text">
                                FOR BILINGUAL SPELLING ENTHUSIASTS, WE OFFER A WEALTH OF ONLINE LEARNING RESOURCES AND PRACTICE EXERCISES. BOOST YOUR BILINGUAL SPELLING ABILITIES AND GEAR UP FOR THE COMPETITION WITH OUR ALL-ROUND SUPPORT! EXPLORE NOW TO START YOUR BILINGUAL SPELLING JOURNEY!
                            </div>
                            <div class="resources-button" @click="goToResources">
                                LEARN MORE
                            </div>
                        </div>
                    </div>
                </div>

                <!-- OUR HONOR Section -->
                <div class="homepage-section honor-section">
                    <div class="honor-title">OUR HONOR</div>
                    <div class="honor-champions-list">
                        <div
                            class="honor-champion-item"
                            v-for="(c, idx) in homeChampions"
                            :key="idx"
                        >
                            <div
                                class="honor-champion-badge"
                                :style="{
                                    backgroundImage: `url(${getChampionBadgeIcon(idx)})`
                                }"
                            >
                                <div class="honor-badge-text">
                                    {{ getBadgeText(idx) }}
                                </div>
                            </div>
                            <div class="honor-champion-image-wrapper">
                                <img
                                    :src="c.img"
                                    alt=""
                                    class="honor-champion-image"
                                />
                            </div>
                            <div class="honor-champion-name">{{ c.name }}</div>
                            <div class="honor-champion-title">{{ c.badge }}</div>
                            <div class="honor-champion-school">{{ c.school }}</div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        </div>
        <BottomTabView class="bottomBar"></BottomTabView>

        <!-- 视频播放模态框 -->
        <div
            v-if="showVideoModal"
            class="video-modal-overlay"
            @click="closeVideoModal"
        >
            <div class="video-modal-content" @click.stop>
                <div class="video-modal-header">
                    <h3 class="video-modal-title">
                        {{ currentVideo ? currentVideo.title : "" }}
                    </h3>
                    <button class="video-modal-close" @click="closeVideoModal">
                        ×
                    </button>
                </div>
                <div class="video-modal-body">
                    <video
                        v-if="currentVideo"
                        :src="currentVideo.videoUrl"
                        controls
                        controlsList="nodownload noremoteplayback"
                        autoplay
                        class="video-modal-player"
                    >
                        您的浏览器不支持视频播放。
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BottomTabView from '@/components/BottomTabView'
import homeBannerView from '@/components/homeBannerView'
export default {
  props: {
    dataHeight: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      bannerHeight: '200px',
      // images: [{ url: 'https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_banner.png' }],
      // images: [{ url: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/banner-cebsb.jpg' }],
      images: [{ url: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_banner.jpg' }],
      // Vision section image
      visionImageUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/hoomepage_img1.png',
      // 视频模态框相关
      showVideoModal: false,
      currentVideo: null,
      featuredList: [
        { titleStr: 'Chinese-English Bilingual Courses', imageUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_activities1.jpg', descStr: 'According to the cognitive characteristics, language acquisition rules and listening, speaking, reading and writing needs of young people of different ages, four thematic courses are customized to systematically improve Chinese-English bilingual literacy.' },
        { titleStr: 'Chinese-English Bilingual Club', imageUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_activities2.jpg', descStr: 'Planning and organizing Chinese-English bilingual competition activities such as Weekly Challenge and Monthly Challenge to display the charm of Chinese and English through popular Chinese characters and annual Chinese characters from ancient to modern.' },
        { titleStr: 'Chinese-English Bilingual Study Tours', imageUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_activities3.jpg', descStr: 'Organizing a study tour on characters and civilization along 30° North Latitude. Building a bridge using Chinese and English languages to connect interdisciplinary knowledge and perceptual inquiry, and gain insight into the light of human civilization through the exploration of languages and characters.' }
      ],
      homeChampions: [
        {
          name: 'Pan Youqi',
          badge: 'Champion of the First Season',
          school: 'Grade 1, Shanghai Concord Bilingual School',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_photo1.png'
        },
        {
          name: 'Jin Hao',
          badge: 'Champion of the Second Season',
          school: 'Grade 6, Shanghai Xiwai International School',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_photo2.png'
        },
        {
          name: "Li Duan'ang",
          badge: 'Champion the Third Season',
          school: 'Grade 7, TEDA No.1 Middle School',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_photo3.png'
        }
      ],
      competitionVideos: [
        {
          title: '小初组',
          titleEn: 'BEGINNER GROUP',
          thumbnail: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/14.jpg',
          videoUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/threeFinalVideo.mp4'
        },
        {
          title: '小中组',
          titleEn: 'INTERMEDIATE GROUP',
          thumbnail: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/15.jpg',
          videoUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/threeFinalVideo.mp4'
        },
        {
          title: '小高组',
          titleEn: 'ADVANCED GROUP',
          thumbnail: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/16.jpg',
          videoUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/threeFinalVideo.mp4'
        },
        {
          title: '初中组',
          titleEn: 'MIDDLE SCHOOL GROUP',
          thumbnail: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/17.jpg',
          videoUrl: 'https://cdn.spbcn.org/spbcnWeb/cebsb/new/3nd_photo/threeFinalVideo.mp4'
        }
      ],
      menuList: [
        { imgUrl: require('../assets/images/homepage_icon1.png'), title: 'About Spelling Bee', desc: 'The first Spelling Bee event in history was documented in 1852, and the first national Spelling Bee was launched by American Courier-Journal in 1925, generating widespread interest throughout the United States and later around the world. As an international event, Spelling Bee is not only a simple spelling activity, but also a bridge for young people from different countries to communicate and share the beauty of their own cultures.' },
        { imgUrl: require('../assets/images/homepage_icon2.png'), title: 'About CEBSB', desc: 'As the first Chinese-English bilingual language communication activity in the world, CEBSB integrates language literacy development into competitive games “Open the door to the mystery of Chinese characters with English, Explore the gene sequences of Chinese characters with English,” thereby building young people’s resilience, and helping them grow into future talents with cross-cultural thinking and global understanding.' },
        { imgUrl: require('../assets/images/homepage_icon3.png'), title: 'Our Vision', desc: 'CEBSB uses language as a bridge to link young people from all over the world who are learning Chinese and English, build a platform on which  they can interact in an open, appropriate and effective way to understand and appreciate others‘ views and  the beauty of other glorious cultures.' }
      ],
      tabIndex: 0,
      prevTabIndex: 0,
      slideName: 'fade-slide-right',
      s2MainHeight: 'auto',
      tabs: [
        {
          t1: 'Season 3',
          nameKey: 'homes2tab1name',
          areaKey: 'homes2tab1area',
          gradeKey: 'homes2tab1grade',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/web/liduanang.png'
        },
        {
          t1: 'Season 2',
          nameKey: 'homes2tab2name',
          areaKey: 'homes2tab2area',
          gradeKey: 'homes2tab2grade',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/web/jinhao.png'
        },
        {
          t1: 'Season 1',
          nameKey: 'homes2tab3name',
          areaKey: 'homes2tab3area',
          gradeKey: 'homes2tab3grade',
          img: 'https://cdn.spbcn.org/spbcnWeb/cebsb/web/panyouqi.png'
        }
      ],
      s4List: [
        {
          usernameKey: 'homes4S1Username',
          gradeKey: 'homes4S1Grade',
          contentKey: 'homes4S1Content'
        },
        {
          usernameKey: 'homes4S2Username',
          gradeKey: 'homes4S2Grade',
          contentKey: 'homes4S2Content'
        },
        {
          usernameKey: 'homes4S3Username',
          gradeKey: 'homes4S3Grade',
          contentKey: 'homes4S3Content'
        },
        {
          usernameKey: 'homes4S4Username',
          gradeKey: 'homes4S4Grade',
          contentKey: 'homes4S4Content'
        },
        {
          usernameKey: 'homes4S5Username',
          gradeKey: 'homes4S5Grade',
          contentKey: 'homes4S5Content'
        }
      ]
    }
  },
  methods: {
    seeMore (type) {
      if (type === 1) {
        this.$store.commit('SET_ACTIVEMENUINDEX', 2)
        this.$router.push('/invGameType')
      } else if (type === 2) {
        this.$store.commit('SET_ACTIVEMENUINDEX', 1)
        this.$router.push('/aboutBackground')
      }
    },
    handleTopScroll (e) {
      // 顶层滚动容器监听
      this.$log.debug('HomeView', 'top-backview scrollTop =', e.target.scrollTop)
    },
    handleContentScroll (e) {
      // 内层滚动容器监听
      this.$log.debug('HomeView', 'contnet-backview scrollTop =', e.target.scrollTop)
    },
    handleWindowScroll () {
      // 窗口滚动监听（方案一）
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      this.$log.debug('HomeView', 'window scrollY =', scrollY)
    },
    learnMore (val) {
      if (val === 0) {
        this.$router.push('/bilingualCourses')
      } else if (val === 1) {
        this.$router.push('/competitiveCommAct')
      } else {
        this.$router.push('/studyTours')
      }
    },
    inFun (i) {
      this.$refs.learnMore[i].style.transform = 'scale(1.1,1.1)'
      this.$refs.learnMore[i].style.transition = '0.3s'
    },
    outFun (i) {
      this.$refs.learnMore[i].style.transform = 'scale(1,1)'
    },
    turunToIndividual () {
      this.$router.push('/invGameType')
    },
    turnToTeam () {
      this.$router.push('/teamGameType')
    },
    goAboutHonour () {
      this.$router.push('/aboutHonour')
    },
    goToPartner () {
      // 跳转到合作伙伴页面，如果路由不存在可以自定义
      // this.$router.push('/partner')
      this.$router.push('/aboutBackground')
    },
    goToResources () {
      // 跳转到资源页面，如果路由不存在可以自定义
      // this.$router.push('/resources')
      this.$router.push('/speOnlineLearningResource')
    },
    switchTab (i) {
      this.prevTabIndex = this.tabIndex
      this.tabIndex = i
      this.slideName = i > this.prevTabIndex ? 'fade-slide-right' : 'fade-slide-left'
      this.setS2MainHeight()
    },
    setS2MainHeight () {
      this.$nextTick(() => {
        const el = this.$refs.s2Main
        if (el) {
          this.s2MainHeight = el.offsetHeight + 'px'
        }
      })
    },
    getChampionBadgeIcon (idx) {
      const icons = [
        'https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_Icon_bg.png',
        'https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_Icon_bg.png',
        'https://cdn.spbcn.org/spbcnWeb/cebsb/homepage_Icon_bg.png'
      ]
      return icons[idx] || icons[0]
    },
    getBadgeText (idx) {
      const texts = ['1st Season', '2nd Season', '3rd Season']
      return texts[idx] || texts[0]
    },
    playVideo (video) {
      this.currentVideo = video
      this.showVideoModal = true
    },
    closeVideoModal () {
      this.showVideoModal = false
      this.currentVideo = null
    }
  },
  computed: {
    // tabs 内容跟随语言切换，依赖 $i18n.locale 自动更新
    i18nTabs () {
      return this.tabs.map(item => ({
        ...item,
        name: this.$t('h.' + item.nameKey),
        area: this.$t('h.' + item.areaKey),
        grade: this.$t('h.' + item.gradeKey)
      }))
    },
    // s4List 评价内容跟随语言切换
    i18nS4List () {
      return this.s4List.map(item => ({
        username: this.$t('h.' + item.usernameKey),
        grade: this.$t('h.' + item.gradeKey),
        content: this.$t('h.' + item.contentKey)
      }))
    }
  },
  watch: {
    // 语言切换时强制触发响应式更新
    '$i18n.locale' () {
      this.$forceUpdate()
    }
  },
  components: {
    homeBannerView,
    BottomTabView
  },
  mounted () {
    // 初始化 s2-main 高度，避免切换时容器跳动
    this.setS2MainHeight()
    // 绑定滚动事件监听
    try {
      if (this.$refs.topBackview && this.$refs.topBackview.addEventListener) {
        this.$refs.topBackview.addEventListener('scroll', this.handleTopScroll, { passive: true })
      }
      if (this.$refs.contentBackview && this.$refs.contentBackview.addEventListener) {
        this.$refs.contentBackview.addEventListener('scroll', this.handleContentScroll, { passive: true })
      }
      // 监听窗口滚动
      window.addEventListener('scroll', this.handleWindowScroll, { passive: true })
    } catch (e) { }
  },
  beforeDestroy () {
    // 移除监听
    try {
      if (this.$refs.topBackview && this.$refs.topBackview.removeEventListener) {
        this.$refs.topBackview.removeEventListener('scroll', this.handleTopScroll)
      }
      if (this.$refs.contentBackview && this.$refs.contentBackview.removeEventListener) {
        this.$refs.contentBackview.removeEventListener('scroll', this.handleContentScroll)
      }
      window.removeEventListener('scroll', this.handleWindowScroll)
    } catch (e) { }
  }
}
</script>

<style lang="less" scoped>
/* s2-main 切换动画：淡入 + 左右滑动 */
.fade-slide-right-enter-active,
.fade-slide-right-leave-active,
.fade-slide-left-enter-active,
.fade-slide-left-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}
/* 右滑效果（tab往右切，内容从右滑入） */
.fade-slide-right-enter {
  opacity: 0;
  transform: translateX(60px);
}
.fade-slide-right-leave-to {
  opacity: 0;
  transform: translateX(-60px);
}
/* 左滑效果（tab往左切，内容从左滑入） */
.fade-slide-left-enter {
  opacity: 0;
  transform: translateX(-60px);
}
.fade-slide-left-leave-to {
  opacity: 0;
  transform: translateX(60px);
}

/* Impact 字体定义 */
@font-face {
    font-family: 'Impact';
    src: local('Impact'), local('Impact-Regular');
    font-weight: normal;
    font-style: normal;
}

/* 首页全局字体设置为 Impact */
.contnet-backview {
    width: 100%;
    background-color: #8c2025;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
}
.banner_bottom_str {
    width: 500px;
    height: 63px;
    margin: 20px 0px;
}
.bannerclass {
    width: 100%;
    height: 550px;
    // background-color: rgb(0, 0, 0);
}
.banner-img-class {
    width: 100%;
    height: 330px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
}
.center-contentview {
    width: 1000px;
    /*background-color: #ffffff;*/
    display: flex;
    flex-direction: column;
    /*align-items: center;*/
}
.section1, .section2, .section3, .section4 {
    margin-top: 80px;
}

.scroll-container {
  overflow: hidden;
  margin-top: 40px;
}

.scroll-track {
  display: flex;
  width: max-content;
  animation: scroll-loop 80s linear infinite;
  animation-play-state: running;
}

.scroll-track:hover {
  animation-play-state: paused;
}

@keyframes scroll-loop {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.flip-card{
  width: 32.5%;
  background-position: center;
  background-size: cover;
  margin-top: 10px;
  perspective: 1000px;  // 3D 透视
  cursor: pointer;
  .c1{
    width: 100%;
    height: 220px;
    background-image: url(https://cdn.spbcn.org/spbcnWeb/cebsb/web/home-s1-bg1.png);
  }
  .c2{
    width: 100%;
    height: 220px;
    background-image: url(https://cdn.spbcn.org/spbcnWeb/cebsb/web/home-s1-bg2.png);
  }
  .c3{
    width: 100%;
    height: 220px;
    background-image: url(https://cdn.spbcn.org/spbcnWeb/cebsb/web/home-s1-bg3.png);
  }
  .flip-inner{
    position: relative;
    width: 100%;
    transition: transform 0.6s;
    transform-style: preserve-3d;
  }
  &:hover .flip-inner{
    transform: rotateY(180deg);  // 悬停翻转
  }
  .flip-front, .flip-back{
    width: 100%;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .s1-icon{
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }
    .s1-tit{
      color: #fff;
      font-family: Impact, alih;
      font-size: 30px;
    }
    .s1-text{
      color: #fff;
      font-family: alim;
      font-size: 16px;
      text-align: center;
      width: 90%;
    }
  }
  .flip-back{
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(180deg);  // 背面预旋转
  }
}
.page-btn{
  background-color: #AA3730;
  color: #fff;
  font-family: alim;
  font-size: 14px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: 20px;
  cursor: pointer;
  &:hover{
    background-color: #fff;
    color: #AA3730;
  }
}
.page-btn2{
  width: 100%;
  &:hover{
    border: 1px solid #AA3730;
  }
}
.s2-con{
  padding: 30px 40px;
  background-color: #fff;
  margin-top: 40px;
  position: relative;
}
.s2-con-inner{
  position: relative;
}
.s2-main-wrap{
  position: relative;
  overflow: hidden;  /* 固定高度容器，切换时不塌陷 */
}
.s2-main{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.s2-tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  .s2-tab-item{
    background-color: #7B7B7B;
    color: #fff;
    width: 32.5%;
    height: 68px;
    text-align: center;
    cursor: pointer;
    text-transform: uppercase;
    &.active, &:hover{
      background-color: #A42C27;
    }
    .t1{
      font-size: 22px;
      font-family: Impact, alim;
      padding-top: 10px;
    }
    .t2{
      font-family: alim;
      font-size: 12px;
    }
  }
}
.section2{
  .page-btn{
    &:hover{
      border: 1px solid #A42C27;
    }
  }
  .s2-main{
  }
  .tit1{
    font-family: Impact, alih;
    font-size: 40px;
    color: #000000;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .tit2{
    font-family: alim;
    font-size: 16px;
    color: #7B7B7B;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  .photo{
    width: 70%;
    height: 270px;
    object-fit: cover;
  }
  .page-btn{
    margin-top: 20px;
  }

}
.s3-con{
  padding: 30px 40px;
  background-color: #fff;
  margin-top: 40px;
  position: relative;
  img{
    width: 36%;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.35);
    margin-right: 20px;
  }
}
.s3-tab-item{
  width: 32%;
  .t1{
    color: #fff;
    font-family: Impact, alih;
    font-size: 18px;
    background-color: #1F1F1F;
    text-align: center;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
  }
  .t2{
    font-family: alim;
    font-size: 12px;
    color: #7B7B7B;
    height: 100px;
    text-align: center;
  }
}
.s4-item{
  flex-shrink: 0;
  width: 380px;
  height: 380px;
  background-color: #fff;
  padding: 20px 30px;
  margin-right: 20px;
  .t1{
    color: #fff;
    background-color: #1F1F1F;
    text-align: center;
    font-size: 22px;
    font-family: Impact, alih;
    line-height: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
  .t2{
    color: #7B7B7B;
    font-size: 14px;
    font-family: Impact, alih;
    text-align: center;
    margin-bottom: 20px;
  }
  .t3{
    color: #7B7B7B;
    font-size: 12px;
    font-family: alim;
    text-align: justify;
  }
  .star{
    text-align: center;
    img{
      width: 18px;
      height: 18px;
      margin: 0 6px 10px;
    }
  }
}
/* Vision section styles */
.vision-section {
    width: 1000px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.vision-image-wrap {
    width: 560px;
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.vision-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.vision-card-wrap {
    position: relative;
    width: 480px;
    margin-left: -120px; /* 覆盖左侧图片一部分 */
    z-index: 2;
}
.vision-card-base {
    position: absolute;
    inset: 0;
    background-color: #b30011; /* 红色底层 */
    transform: translate(-10px, 10px); /* 向左下偏移 10px */
}
.vision-card {
    position: relative;
    background-color: #ffffff; /* 白色上层 */
    padding: 24px 28px;
    min-height: 240px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}
.vision-subtitle {
    font-size: 20px;
    font-weight: 700;
    color: #b30011;
    letter-spacing: 1px;
    margin-bottom: 8px;
}
.vision-title {
    font-size: 30px;
    font-weight: 900;
    color: #000000;
    font-family: "hzgb";
    margin-bottom: 16px;
}
.vision-text {
    font-size: 16px;
    line-height: 1.4;
    color: #747474;
}
.center-menu-backview {
    width: 1000px;
    margin-top: 20px;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    display: -webkit-box;
}
.down_background {
    width: 1000px;
    height: 245px;
}

/* OUR CHAMPION (home) */
.home-champions-section {
    width: 1000px;
    margin: 10px 0 30px;
}
.home-champions-list {
    width: 960px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}
.home-champion-item {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
/* 复用 aboutHonour 圆形图样式 */
.champion-image-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
}
.champion-image-background {
    position: relative;
    width: 220px;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.champion-bg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
}
.champion-foreground {
    width: 68%;
    height: 68%;
    object-fit: cover;
    position: relative;
    top: -18px;
    left: -10px;
    z-index: 1;
    border-radius: 50%;
}
.home-champion-name {
    margin-top: 16px;
    font-size: 26px;
    font-weight: 900;
    color: #a48c4e;
}
.home-champion-badge {
    margin-top: 12px;
    padding: 6px 14px;
    background-color: #821d21;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 4px;
}
.home-champion-school {
    margin-top: 10px;
    font-size: 14px;
    color: #b01e1b;
    text-align: center;
}
.home-champions-more {
    width: 960px;
    margin: 16px auto 0;
    text-align: right;
    font-weight: 900;
    color: #b30011;
    cursor: pointer;
    letter-spacing: 1px;
}
.home-champions-more:hover {
    text-decoration: underline;
}
.menu-childback {
    width: 300px;
    display: flex;
    margin-left: 25px;
    padding: 30px 0px 10px 0px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0px 0px 5px #b8b8b8;
}
.menu-child-topimg1 {
    width: 100px;
    height: 87px;
    margin-bottom: 13px;
}
.menu-child-topimg {
    width: 100px;
    height: 100px;
}
.menu-child-title {
    width: 270px;
    font-size: 22px;
    margin: 10px 0px;
    font-weight: 900;
    text-align: center;
    color: #040404;
}
.menu-child-desc {
    width: 270px;
    font-size: 12px;
    line-height: 20px;
    margin: 10px 0px;
    text-align: left;
    color: #947b3e;
}
.contnet-titleback {
    width: 940px;
    margin: 30px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.titleback-leftimg {
    width: 30px;
    height: 30px;
}
.titleback-rightStr {
    margin-left: 10px;
    font-size: 18px;
    text-align: left;
    color: #b30011;
    font-weight: 600;
}
.competition-contentback {
    width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // background-color: #99a9bf;
}
.competition-contentview {
    width: 550px;
    background-color: #e2e2e2;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.competition-image {
    height: 200px;
    width: 220px;
    object-fit: contain;
}
.competition-titleStr {
    width: 280px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    // background-color: #c6c6c6;
}
.competition-title-str {
    width: 280px;
    margin: 10px;
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    color: black;
}
.competition-desc-str {
    width: 280px;
    margin: 0px 10px;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
    color: #797979;
    overflow: hidden;
}
.competition-centerLine {
    width: 1px;
    min-height: 200px;
    padding: 0px 0px;
    background-color: rgb(176, 176, 176);
    // border: 0.5px dashed rgb(55, 55, 55);
}

/* Competition Introduction Styles */
.competition-intro-content {
    width: 960px;
    display: flex;
    flex-direction: row;
    margin: 20px 0px;
}

.video-grid {
    width: 480px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
}

.video-item {
    position: relative;
    width: 100%;
    height: 200px;
}

.video-thumbnail {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
}

.video-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
}

.video-thumbnail:hover .video-overlay {
    background-color: rgba(0, 0, 0, 0.7);
}

.play-button {
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    transition: transform 0.3s ease, background-color 0.3s ease;
}

.play-button:hover {
    transform: scale(1.1);
    background-color: rgba(255, 255, 255, 1);
}

.play-icon {
    width: 0;
    height: 0;
    border-left: 20px solid #333;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    margin-left: 4px;
}

.video-info {
    text-align: center;
    color: white;
}

.video-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

.video-title-en {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
    opacity: 0.9;
}

.video-number {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 2px;
}

.video-sub-number {
    font-size: 16px;
    font-weight: 500;
    opacity: 0.8;
}

.competition-description {
    width: 480px;
    padding: 20px;
}

.description-title {
    font-size: 24px;
    font-weight: bold;
    color: #040404;
    margin-bottom: 20px;
    text-align: center;
}

.description-content {
    font-size: 14px;
    line-height: 1.6;
    color: #4a4a4a;
}

.description-content p {
    margin-bottom: 15px;
    text-align: justify;
}
.activity-contentback {
    width: 960px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-bottom: 20px;
}
.activity-contentview {
    width: 280px;
    display: flex;
    flex-direction: column;
    background-color: white;
    align-items: center;
    box-shadow: 6px 6px 5px #b8b8b8;
    margin-bottom: 10px;
    padding-bottom: 50px;
    position: relative;
}
.activity-content-topview {
    width: 280px;
    height: 188px;
}
.activity-content-topimg {
    width: 55px;
    height: 55px;
}
.activity-contentview-titlestr {
    width: 280px;
    margin: 15px 0;
    font-size: 13px;
    height: 15px;
    font-weight: 700;
    color: #a7041d;
    text-align: left;
}
.activity-contentview-line {
    width: 260px;
    height: 2px;
    background-color: black;
    // margin-bottom: 15px;
    margin: 0px 0px 15px 0px;
    // margin-left: 10px;
}
.activity-contentview-descStr {
    width: 260px;
    // color: #4d4d4d;
    // font-size: 12px;
    // line-height: 20px;
    text-align: left;
}
.activity-contentview-bottom {
    width: 260px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 10px;
}
.activity-contentview-moreview {
    width: 120px;
    height: 25px;
    background-image: url(../assets/images/homepage_button.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    // background-color: black;
    // display: flex;
    // position: relative;
    // flex-direction: row;
    // align-items: center;
}
.activity-moreview-img {
    width: 15px;
    height: 15px;
}
.transform {
    transform: rotate(180deg);
}
.bottom-banner {
    width: 650px !important;
    height: 220px !important;
    // margin-left: 50px;
    // display: flex !important;
    // align-items: center !important;
    // justify-content: center !important;
    margin-top: 40px;
}
.el-carousel /deep/ .el-carousel__container {
    height: 220px !important;
}
.el-carousel__item {
    width: 295px;
    height: 220px;
}
// .bottombanner-img-class {
//   width: 200px;
//   height: 150px;
//   background-repeat: no-repeat;
//   background-size: 100% 100%;
//   -moz-background-size: 100% 100%;
// }
.bottom-cooperation-view {
    width: 1000px;
    height: 209px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(https://cdn.spbcn.org/spbcnWeb/cebsb/new/homepage_cooperation.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
}
.cooperation-leftview {
    height: 42px;
    color: #fffdf9;
    font-size: 24px;
    font-weight: 900;
    line-height: 42px;
    padding: 5px 20px;
    border: 4px solid #a59d8a;
}

.el-carousel {
    width: 1000px;
    height: 330px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
}
.spin_img {
    width: 100%;
    height: 100%;
}

/* 视频模态框样式 */
.video-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

.video-modal-content {
    background-color: #ffffff;
    border-radius: 12px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    animation: slideIn 0.3s ease;
}

.video-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 25px;
    border-bottom: 1px solid #e0e0e0;
    background-color: #f8f9fa;
}

.video-modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;

}

.video-modal-close {
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}

.video-modal-close:hover {
    background-color: #e0e0e0;
    color: #333;
}

.video-modal-body {
    padding: 0;
    position: relative;
}

.video-modal-player {
    width: 100%;
    height: auto;
    max-height: 60vh;
    display: block;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Homepage Sections - New Design */
.homepage-section {
    width: 100%;
    background-color: #8c2025;
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Global Partner Section */
.global-partner-section {
    background-color: #8c2025;
}

.global-partner-content {
    width: 1200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
}

.global-partner-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #ffffff;
}

.global-partner-subtitle {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.global-partner-title {
    font-size: 32px;
    font-weight: 900;
    font-family: Impact, "Arial Black", sans-serif;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 24px;
}

.global-partner-description {
    font-size: 14px;
    color: #ffffff;
    line-height: 1.6;
    margin-bottom: 32px;
}

.global-partner-button {
    width: fit-content;
    padding: 12px 24px;
    border-radius: 8px;
    background-color: #ffffff;
    border: 2px solid #8c2025;
    color: #8c2025;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
}

.global-partner-button:hover {
    background-color: #8c2025;
    color: #ffffff;
    border-color: #ffffff;
}

.global-partner-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.global-partner-panel {
    position: relative;
    width: 400px;
    height: 400px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: 60px;
    overflow: hidden;
}

.global-partner-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    position: relative;
    z-index: 1;
    padding: 20px;
}

.global-partner-vertical-text {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: 24px;
    font-weight: 900;
    color: #8c2025;
    letter-spacing: 4px;
    padding: 20px 0;
    background-color: #d4af37;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

/* Bilingual Spelling Resources Section */
.resources-section {
    background-color: #ffffff;
}

.resources-content {
    width: 1050px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
}

.resources-left {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.resources-image {
    width: 100%;
    max-width: 450px;
    height: auto;
    object-fit: contain;
}

.resources-right {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.resources-text {
    font-size: 22px;
    font-weight: 700;
    color: #767676;
    text-transform: uppercase;
    line-height: 1.6;
    letter-spacing: 0.5px;
    font-family: Impact, "Arial Black", sans-serif;
    margin-bottom: 24px;
}

.resources-button {
    width: fit-content;
    padding: 10px 20px;
    background-color: #8c2025;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #ffffff;
}

.resources-button:hover {
    background-color: #ffffff;
    color: #8c2025;
    border: 2px solid #8c2025;
}

/* OUR HONOR Section */
.honor-section {
    background-color: #8c2025;
    padding-bottom: 80px;
}

.honor-title {
    font-size: 42px;
    font-weight: 900;
    color: #ffffff;
    text-transform: uppercase;
    font-family: Impact, "Arial Black", sans-serif;
    text-align: center;
    margin-bottom: 50px;
    letter-spacing: 2px;
}

.honor-champions-list {
    width: 1000px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;
    padding: 0 20px;
}

.honor-champion-item {
    width: 300px;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 40px 20px 20px;
    position: relative;
}

.honor-champion-badge {
    position: absolute;
    width: 130px;
    height: 40px;
    top: -40px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
}
.honor-badge-text {
    color: white;
    font-size: 18px;
    font-weight: 900;
    font-family: Impact, "Arial Black", sans-serif;
    text-align: center;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}
.honor-badge-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.honor-champion-image-wrapper {
    width: 300px;
    height: 200px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    // border-radius: 12px;
}

.honor-champion-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    // border-radius: 12px;
}

.honor-champion-name {
    font-size: 24px;
    font-family: Impact, "Arial Black", sans-serif;
    font-weight: 900;
    color: #ffffff;
    margin-bottom: 8px;
    text-align: center;
}

.honor-champion-title {
    font-size: 14px;
    color: #3d3c3c;
    font-family: Impact, "Arial Black", sans-serif;
    background-color: #ffffff;
    padding: 4px 12px;
    border-radius: 4px;
    margin-bottom: 8px;
    text-align: center;
    display: inline-block;
}

.honor-champion-school {
    font-size: 12px;
    color: #ffffff;
    text-align: center;
}

@media (max-width: 768px) {
  .s1-icon{
    width: 20px !important;
    height: 20px !important;
    margin-bottom: 4px !important;
  }
  .center-contentview {
    width: 90%;
  }
}
</style>
